import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import { Form, Col, Row, Button, Modal } from "react-bootstrap";
import { Typeahead } from "react-bootstrap-typeahead";

import "react-datepicker/dist/react-datepicker.css";
import "../styles/Sample.css";
import { toast } from "react-toastify";
import axiosInstance from "../axiosInstance";

export default function Sample() {
  const [startDate, setStartDate] = useState(new Date());
  const [reference_number, setReferenceNumber] = useState([]);
  const [location, setLocation] = useState("");
  const [persons, setPersons] = useState("");
  const [species, setSpecies] = useState("");
  const [sex, setSex] = useState("Male");
  const [weight, setWeight] = useState(0);
  const [length_cdl, setLengthCDL] = useState(0);
  const [length_full_body, setLengthFullBody] = useState(0);
  const [case_history, setCaseHistory] = useState("");
  const [ectoparasites, setEctoparasites] = useState(false);
  const [ectoparasites_comments, setEctoparasitesComments] = useState("");
  const [scale, setScale] = useState(false);
  const [scale_comments, setScaleComments] = useState("");
  const [skin, setSkin] = useState(false);
  const [skin_comments, setSkinComments] = useState("");
  const [blood, setBlood] = useState(false);
  const [blood_comments, setBloodComments] = useState("");
  const [muscle, setMuscle] = useState(false);
  const [muscle_comments, setMuscleComments] = useState("");
  const [spleen, setSpleen] = useState(false);
  const [spleen_comments, setSpleenComments] = useState("");
  const [heart, setHeart] = useState(false);
  const [heart_comments, setHeartComments] = useState("");
  const [liver, setLiver] = useState(false);
  const [liver_comments, setLiverComments] = useState("");
  const [kidney, setKidney] = useState(false);
  const [kidney_comments, setKidneyComments] = useState("");
  const [lung, setLung] = useState(false);
  const [lung_comments, setLungComments] = useState("");
  const [anaethesia_description, setAnaethesiaDescription] = useState("");
  const [photos_taken, setPhotosTaken] = useState("No");
  const [observations, setObservations] = useState("");
  const [dead, setDead] = useState(false);
  const [options, setOptions] = useState([]);
  const [showSave, setShowSave] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  async function getReferences() {
    const result = await axiosInstance.get("/api/all-reference-numbers");
    const numbers = result.data;
    const refs = [];
    numbers.forEach((element) => {
      refs.push(element.reference_number);
    });
    setOptions(refs);
  }

  const handleCloseSave = () => setShowSave(false);
  const handleCloseSuccess = () => setShowSuccess(false);
  const handleSave = () => {
    submit();
    setShowSave(false);
  };
  function handleShowSave(e) {
    e.preventDefault();
    setShowSave(true);
  }

  useEffect(() => {
    getReferences();
  }, []);

  const toggleDead = () => {
    const temp = !dead;
    setDead(temp);
  };

  async function submit() {
    const ref = reference_number[0];
    const items = {
      date: startDate,
      reference_number: ref,
      dead,
      location,
      persons,
      species,
      sex,
      weight,
      length_cdl,
      length_full_body,
      case_history,
      ectoparasites,
      ectoparasites_comments,
      scale,
      scale_comments,
      skin,
      skin_comments,
      blood,
      blood_comments,
      muscle,
      muscle_comments,
      spleen,
      spleen_comments,
      heart,
      heart_comments,
      liver,
      liver_comments,
      kidney,
      kidney_comments,
      lung,
      lung_comments,
      anaethesia_description,
      photos_taken,
      observations,
    };
    var result = await axiosInstance.post("/api/add-sample", items);
    if (result.data.code !== "ER_PARSE_ERROR") {
      toast.success(result.data, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
      setObservations("");
      setPhotosTaken(false);
      setAnaethesiaDescription("");
      setSkin(false);
      setSkinComments("");
      setLung(false);
      setLungComments("");
      setMuscle(false);
      setMuscleComments("");
      setSpleen(false);
      setSpleenComments("");
      setHeart(false);
      setHeartComments("");
      setEctoparasites(false);
      setEctoparasitesComments("");
      setDead(false);
      setReferenceNumber([]);
      setStartDate(new Date());
      setLocation("");
      setPersons("");
      setSex("Male");
      setWeight(0);
      setLengthCDL(0);
      setLengthFullBody(0);
      setCaseHistory("");
      setBlood(false);
      setBloodComments("");
      setLiver(false);
      setLiverComments("");
      setKidney(false);
      setKidneyComments("");
    } else {
      toast.error(result.data.sqlMessage, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
      });
    }
  }

  return (
    <div className="sample">
      <div className="formGroup">
        <h2 className="heading">Sampling</h2>
        <Form.Group as={Col} controlId="formGroupDate">
          <Form.Check
            className="switch"
            type="switch"
            id="criminal-switch"
            label="Dead Pangolin"
            checked={dead}
            onChange={toggleDead}
          />
          <DatePicker
            className="datepicker"
            selected={startDate}
            onChange={(date) => setStartDate(date)}
            showTimeSelect
            timeIntervals={1}
            dateFormat="dd/MM/yyyy HH:mm"
          />
        </Form.Group>
        <Form>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupReference">
                <Form.Label>Reference Number</Form.Label>
                <Typeahead
                  id="reference-number"
                  labelKey="name"
                  onChange={setReferenceNumber}
                  options={options}
                  placeholder="Choose a reference number..."
                  selected={reference_number}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupLocation">
                <Form.Label>Location</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Location"
                  value={location}
                  onChange={(e) => setLocation(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={6}>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Label>Person(s) Who Conducted Sampling</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  placeholder="Person(s) Who Conducted Sampling"
                  value={persons}
                  onChange={(e) => setPersons(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupSpecies">
                <Form.Label>Species</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Species"
                  value={species}
                  onChange={(e) => setSpecies(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupSex">
                <Form.Label>Sex</Form.Label>
                <Form.Control
                  as="select"
                  defaultValue={sex}
                  onChange={(e) => setSex(e.target.value)}
                >
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </Form.Control>
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupManufacturer">
                <Form.Label>Weight</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Weight"
                  value={weight}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setWeight(s);
                    } else if (e.target.value === "") {
                      setWeight(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupManufacturer">
                <Form.Label>Length (CDL in a ball)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Length (CDL in a ball)"
                  value={length_cdl}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setLengthCDL(s);
                    } else if (e.target.value === "") {
                      setLengthCDL(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupManufacturer">
                <Form.Label>Length (Full Body)</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Length (Full Body)"
                  value={length_full_body}
                  onChange={(e) => {
                    const regex = new RegExp(
                      "^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$"
                    );
                    if (regex.test(e.target.value)) {
                      const s = e.target.value.replace(
                        /^(?:0+(?=[1-9])|0+(?=0$))/gm,
                        ""
                      );
                      setLengthFullBody(s);
                    } else if (e.target.value === "") {
                      setLengthFullBody(0);
                    }
                  }}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Label>Case History</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Case History"
                  value={case_history}
                  onChange={(e) => setCaseHistory(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <h3>Samples</h3>
          <Row>
            <Col xs={1}>
              <Form.Group as={Col} controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Ectoparasites"
                  value={!ectoparasites}
                  onChange={(e) => setEctoparasites(e.target.value === "true")}
                  checked={ectoparasites}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments"
                  value={ectoparasites_comments}
                  onChange={(e) => setEctoparasitesComments(e.target.value)}
                  disabled={!ectoparasites}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <Form.Group as={Col} controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Scale"
                  value={!scale}
                  onChange={(e) => setScale(e.target.value === "true")}
                  checked={scale}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments"
                  value={scale_comments}
                  onChange={(e) => setScaleComments(e.target.value)}
                  disabled={!scale}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <Form.Group as={Col} controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Skin"
                  value={!skin}
                  onChange={(e) => setSkin(e.target.value === "true")}
                  checked={skin}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments"
                  value={skin_comments}
                  onChange={(e) => setSkinComments(e.target.value)}
                  disabled={!skin}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <Form.Group as={Col} controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Blood"
                  value={!blood}
                  onChange={(e) => setBlood(e.target.value === "true")}
                  checked={blood}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments"
                  value={blood_comments}
                  onChange={(e) => setBloodComments(e.target.value)}
                  disabled={!blood}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <Form.Group as={Col} controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Muscle"
                  value={!muscle}
                  onChange={(e) => setMuscle(e.target.value === "true")}
                  checked={muscle}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments"
                  value={muscle_comments}
                  onChange={(e) => setMuscleComments(e.target.value)}
                  disabled={!muscle}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <Form.Group as={Col} controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Spleen"
                  value={!spleen}
                  onChange={(e) => setSpleen(e.target.value === "true")}
                  checked={spleen}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments"
                  value={spleen_comments}
                  onChange={(e) => setSpleenComments(e.target.value)}
                  disabled={!spleen}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <Form.Group as={Col} controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Heart"
                  value={!heart}
                  onChange={(e) => setHeart(e.target.value === "true")}
                  checked={heart}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments"
                  value={heart_comments}
                  onChange={(e) => setHeartComments(e.target.value)}
                  disabled={!heart}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <Form.Group as={Col} controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Liver"
                  value={!liver}
                  onChange={(e) => setLiver(e.target.value === "true")}
                  checked={liver}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments"
                  value={liver_comments}
                  onChange={(e) => setLiverComments(e.target.value)}
                  disabled={!liver}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <Form.Group as={Col} controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Kidney"
                  value={!kidney}
                  onChange={(e) => setKidney(e.target.value === "true")}
                  checked={kidney}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments"
                  value={kidney_comments}
                  onChange={(e) => setKidneyComments(e.target.value)}
                  disabled={!kidney}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={1}>
              <Form.Group as={Col} controlId="formBasicCheckbox">
                <Form.Check
                  type="checkbox"
                  label="Lung"
                  value={!lung}
                  onChange={(e) => setLung(e.target.value === "true")}
                  checked={lung}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Comments"
                  value={lung_comments}
                  onChange={(e) => setLungComments(e.target.value)}
                  disabled={!lung}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Label>
                  Briefly Describe the Anethesia for Blood Draw
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder=" Briefly Describe the Anethesia for Blood Draw"
                  value={anaethesia_description}
                  onChange={(e) => setAnaethesiaDescription(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col xs={3}>
              <Form.Group as={Col} controlId="formGroupPhotos">
                <Form.Label>Photos Taken</Form.Label>
                <Form.Check
                  type="radio"
                  id="photo-radio-yes"
                  label="Yes"
                  name="photoRadios"
                  value="Yes"
                  onChange={(e) => setPhotosTaken(e.target.value)}
                  checked={photos_taken === "Yes"}
                />
                <Form.Check
                  type="radio"
                  id="photo-radio-no"
                  label="No"
                  name="photoRadios"
                  value="No"
                  onChange={(e) => setPhotosTaken(e.target.value)}
                  checked={photos_taken === "No"}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group as={Col} controlId="formGroupDetails">
                <Form.Label>Any Other Observations</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  placeholder="Any Other Observations"
                  value={observations}
                  onChange={(e) => setObservations(e.target.value)}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                className="submit-button"
                type="submit"
                onClick={(e) => {
                  handleShowSave(e);
                }}
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Form>
      </div>
      <div>
        <Modal show={showSave} onHide={handleCloseSave}>
          <Modal.Header closeButton>
            <Modal.Title>Save</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <p>Are you sure you want to save this device.</p>
          </Modal.Body>

          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSave}>
              Close
            </Button>
            <Button variant="primary" onClick={handleSave}>
              Save changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <Modal show={showSuccess} onHide={handleCloseSuccess}>
          <Modal.Header closeButton>
            <Modal.Title>Success</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p>Successfuly Submited.</p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseSuccess}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
}
